import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { HomePage } from '../home/home'; 
import { CollectiblesRewardPage } from '../collectiblesreward/collectiblesreward'; 

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { UserdataModel } from '../../providers/userdata-model';
import { GamerulesModel } from '../../providers/gamerules-model'; 

@Component({
  selector: 'page-collectibles',
  templateUrl: 'collectibles.html',
  host: { '(window:resize)': 'handleResizeEvents($event)'}
})
export class CollectiblesPage {

  constructor(public functions: Functions, public rubedoSideMenu: MenuController, public userdataModel:UserdataModel, public gamesrulesModel: GamerulesModel, public translate: TranslateService, public navCtrl: NavController) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(this.functions.sidemenuEnabled, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(this.functions.sidemenuEnabled);
  }

  ionViewDidEnter(){
    this.functions.setScaleForBigScreen();
  }

  handleResizeEvents(event: KeyboardEvent) {
    this.functions.setScaleForBigScreen();
  }

  goToMainMenu(){
    this.navCtrl.setRoot(HomePage, {});
  }

  goToCollPage(stepCollectible){
    if (this.functions.stepsForUnlockingCollectiblesThatAreNotLeadingToTextPages.indexOf(stepCollectible) <= -1) {
      this.navCtrl.push(CollectiblesRewardPage, {
        stepCollectible: stepCollectible
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/collectibles/collectibles.ts